import { EnvMap } from "@/constant";
import type { TypeLocalEnv } from "@/types";
import { getLocalEnvStorage, setLocalEnvStorage } from "@/utils/storage";
import { Button, Input, Modal, Select, Space } from "antd";
import React, { ChangeEvent, useEffect, useState } from "react";

const canShowEnvExchange =
  REACT_APP_ENV === "dev" ||
  REACT_APP_ENV === "test" ||
  REACT_APP_ENV === "pre";

const EnvDropdown: React.FC = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [localEnv, setLocalEnv] = useState<TypeLocalEnv>({
    os: "",
    erp: "",
    osHost: "",
    erpHost: "",
    osSuffix: "",
    erpSuffix: "",
  });

  const handleClickEnv = () => {
    setVisible(true);
  };

  const handleEnvChange = (value: Record<string, string | null>) => {
    setLocalEnv((s) => ({ ...s, ...value }));
  };

  const handleEnvConfirm = () => {
    setLocalEnvStorage(localEnv);
    window.location.reload();
  };

  useEffect(() => {
    if (visible) {
      const localEnvData = getLocalEnvStorage();
      setLocalEnv(
        Object.assign(
          {},
          {
            osSuffix: EnvMap.os.suffix[0],
            erpSuffix: EnvMap.erp.suffix[0],
          },
          localEnvData,
        ),
      );
    }
  }, [visible]);

  if (!canShowEnvExchange) {
    return null;
  }

  return (
    <>
      <Button type="text" onClick={handleClickEnv}>
        环境设置
      </Button>
      <Modal
        open={visible}
        title="环境设置"
        width="600px"
        onCancel={() => setVisible(false)}
        onOk={handleEnvConfirm}
      >
        <Space>
          <div style={{ width: "44px" }}>商城：</div>
          <Input
            addonBefore={
              <Select
                value={localEnv.osHost}
                style={{ width: 200 }}
                onChange={(value: string | null) =>
                  handleEnvChange({ osHost: value })
                }
              >
                {EnvMap.os.host.map((item: string) => (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            }
            addonAfter={
              <Select
                value={localEnv.osSuffix}
                style={{ width: 160 }}
                onChange={(value: string | null) =>
                  handleEnvChange({ osSuffix: value })
                }
              >
                {EnvMap.os.suffix.map((item: string) => (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            }
            value={localEnv.os || ""}
            placeholder="需求ID或开发环境值"
            style={{ width: "100%" }}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleEnvChange({ os: e.target.value })
            }
          />
        </Space>
        <Space style={{ marginTop: "24px" }}>
          <div style={{ width: "44px" }}>ERP：</div>
          <Input
            addonBefore={
              <Select
                value={localEnv.erpHost}
                style={{ width: 200 }}
                onChange={(value: string | null) =>
                  handleEnvChange({ erpHost: value })
                }
              >
                {EnvMap.erp.host.map((item: string) => (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            }
            addonAfter={
              <Select
                value={localEnv.erpSuffix}
                style={{ width: 160 }}
                onChange={(value: string | null) =>
                  handleEnvChange({ erpSuffix: value })
                }
              >
                {EnvMap.erp.suffix.map((item: string) => (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            }
            value={localEnv.erp || ""}
            min="1"
            placeholder="需求ID或开发环境值"
            style={{ width: "100%" }}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleEnvChange({ erp: e.target.value })
            }
          />
        </Space>
      </Modal>
    </>
  );
};

export default EnvDropdown;
